<ng-container *ngrxLet="orgData$; let orgData">
    <h1>{{ orgData.product }}</h1>
    <h2>{{ orgData.productType }}</h2>
    <h2>{{ orgData.variant }}</h2>
</ng-container>
<ng-container *ngrxLet="sortedInputFields$; let sortedInputFields">
    <pace-customer-identification-input-field
        class="col"
        [parentForm]="parentForm"
        [property]="inputField.key"
        *ngFor="let inputField of sortedInputFields; trackBy: trackByFn"
    ></pace-customer-identification-input-field>
</ng-container>
<p *ngIf="instructions$ | async as instructions">{{ instructions }}</p>
<ng-container *ngrxLet="copyright$; let copyright">
    <p>{{ copyright.line1 }}</p>
    <p>{{ copyright.line2 }}</p>
</ng-container>
